/* tslint:disable */
/* eslint-disable */
/**
 * Gallaudet
 * A set of APIs to allow seamless integration of the NUSA Roblox game
with Google Classrooms.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';

/**
 * 
 * @export
 * @interface LinkRobloxAccountResponseContent
 */
export interface LinkRobloxAccountResponseContent {
    /**
     * 
     * @type {string}
     * @memberof LinkRobloxAccountResponseContent
     */
    message: string;
}


/**
 * Check if a given object implements the LinkRobloxAccountResponseContent interface.
 */
export function instanceOfLinkRobloxAccountResponseContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "message" in value;
    return isInstance;
}

export function LinkRobloxAccountResponseContentFromJSON(json: any): LinkRobloxAccountResponseContent {
    return LinkRobloxAccountResponseContentFromJSONTyped(json, false);
}

export function LinkRobloxAccountResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): LinkRobloxAccountResponseContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'message': json['message'],
    };
}

export function LinkRobloxAccountResponseContentToJSON(value?: LinkRobloxAccountResponseContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'message': value.message,
    };
}

